<template>
  <div class="float-assignment-step card-base fade-in">
    <div class="greeting-section mb-3">
      <h2 class="greeting-text">{{ greeting() }}</h2>
      <p class="user-name" v-if="currentUser">{{ currentUser }}</p>
    </div>

    <div class="card-body p-4">
      <h4 class="card-title mb-4">
        <span class="gradient-text">Assign Cash</span> <span class="text-primary-color">Float</span>
      </h4>

      <FloatAssignForm @float-assigned="handleFloatAssigned" />
    </div>
  </div>
</template>

<script>
import FloatAssignForm from '@/components/point-of-sale/float/FloatAssignForm.vue';

export default {
  name: 'FloatAssignmentStep',
  components: {
    FloatAssignForm
  },
  computed: {
    currentUser() {
      const user = this.$store && this.$store.getters && this.$store.getters.getCurrentUser;
      return user && user.Username ? user.Username : '';
    }
  },
  methods: {
    greeting() {
      const today = new Date();
      const currentHour = today.getHours();
      const currentMin = today.getMinutes();
      
      if (currentHour >= 0 && (currentHour <= 11 && currentMin <= 59)) {
        return 'Good Morning';
      } else if (currentHour >= 12 && (currentHour <= 17 && currentMin <= 59)) {
        return 'Good Afternoon';
      } else {
        return 'Good Evening';
      }
    },

    handleFloatAssigned() {
      // Emit success to parent when float is assigned
      this.$emit('next', { step: 'float-complete' });
    }
  }
};
</script>

<style lang="scss" scoped>
.float-assignment-step {
  padding: 0;
  width: 100%;
  background-color: var(--card-bg);
  border: var(--card-border);
  box-shadow: var(--card-shadow);
  border-radius: 16px;
  overflow: visible;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: var(--card-shadow-hover);
  }
}

.greeting-section {
  text-align: center;
  padding: 2rem 1rem 0;
  opacity: 1;
  transform: translateY(0);
}

.greeting-text {
  font-size: 2rem;
  font-weight: 700;
  background: linear-gradient(to right, var(--accent-electric-blue), var(--accent-neon-purple));
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 0.5rem;
}

.user-name {
  font-size: 1.2rem;
  color: var(--text-secondary);
  font-weight: 500;
  margin: 0;
}

.card-body {
  padding: 1.5rem 2rem 2rem !important;
  opacity: 1;
  transform: translateY(0);
}

.card-title {
  font-weight: 700;
  letter-spacing: 1.2px;
  margin-bottom: 1.5rem;
  text-align: center;
  font-size: 1.4rem;
}

.text-primary-color {
  color: var(--text-primary);
}

.gradient-text {
  background: linear-gradient(to right, var(--accent-electric-blue), var(--accent-neon-purple), var(--accent-electric-blue));
  background-size: 200% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  opacity: 1;
}

/* Animations removed for compatibility with reduced motion settings */

/* Responsive */
@media (max-width: 768px) {
  .greeting-text {
    font-size: 1.5rem;
  }

  .user-name {
    font-size: 1rem;
  }

  .card-body {
    padding: 1rem 1.5rem 1.5rem !important;
  }

  .card-title {
    font-size: 1.2rem;
  }
}
</style>
